<template>
    <div class="form-group">
        <label v-if="label">{{label}}</label>
        <ul class="list-group">
            <template v-for="file in files">
                <li v-if="file.id" :key="file.id"
                    class="list-group-item d-flex justify-content-between align-items-center">

                    <template v-if="type=='images'">
                        <img :src="file.url" :alt="file.name" class="img-thumbnail">
                    </template>
                    <template v-else>
                        {{file.name}}
                    </template>

                    <button class="btn btn-danger btn-sm" @click.prevent="openDeleteModal(file)">
                        {{Lang.get('messages.delete')}}</button>
                </li>
            </template>
        </ul>

        <modal target="delete-file" :title="Lang.get('messages.delete_file')" ref="deleteModal" @confirm="onDelete">
            <template #body>
                <delete :message="selectedFile.name" />
            </template>
            <template #footer></template>
        </modal>
    </div>
</template>

<script>
    import Files from '@api/file.api';

    export default {
        props: {
            label: {
                type: String
            },

            files: {
                type: Array,
                required: true
            },

            type: {
                type: String,
                default: 'none',
                validator: function (value) {
                    // The value must match one of these strings
                    return ['images', 'none'].indexOf(value) !== -1
                }
            },
        },

        data() {
            return {
                selectedFile: {}
            }
        },

        methods: {
            openDeleteModal(file) {
                this.selectedFile = file;
                this.$refs.deleteModal.open();
            },

            onDelete(file) {
                Files.delete(this.selectedFile).then(response => {
                    let index = this.files.findIndex(
                        p => p.id === this.selectedFile.id
                    );
                    this.files.splice(index, 1);
                    this.selectedFile = {};
                    this.$snotify.success(response.data.message);
                });

                this.$refs.deleteModal.close();
            }
        }
    };

</script>

<style>
    .img-thumbnail {
        height: 100px !important;
    }

</style>
